import { IClinicalNotes, IClinicalReport } from '../interface/clinical-notes';
export class ClinicalNotes implements IClinicalNotes {
    constructor(
       public ClinicalNotesId : number,
       public PatientId : number,
       public ChiefComplaint : string,
       public Observation : string,
       public Investigation : string,
       public Diagnoses : string,
       public Notes : string,
       public Drugs : string,
       public AppointmentId : number,
       public  EnteredBy : string,
       public AppointmentDay : string,
       public  AppointmentTime : string
    ){}
}
export class ClinicalReport implements IClinicalReport {
    constructor(
        public ReportId : number,
        public AppointmentId : number,
        public PatientId : string,
        public FileName : string,
        public FilePath : string,
        public AppointmentDay :string,
        public AppointmentTime : string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/section/patient/model/clinical-notes.ts